import React from 'react';

import cn from "classnames";

const Note = ({ className, count = 1 }) => (
  <div className={ cn("ai-bottom-note", className) }>
    {
      count > 1 ? (
        <>These summaries were created with our BuzzIQ AI technology.</>
      ) : (
        <>This summary was created with our BuzzIQ AI technology.</>
      )
    }
    { ' ' }
    It automatically summarizes and surfaces primary themes to help bring the voice
    { ' ' }
    of the respondent to life and aid reporting diagnostics. Keep in mind this represents
    { ' ' }
    qualitative analysis. Consider reviewing actual responses to increase confidence and/or
    { ' ' }
    make appropriate revisions to
    { ' ' }
    {
      count > 1 ? (
        <>these summaries.</>
      ) : (
        <>this summary.</>
      )
    }
  </div>
);

export default Note;
